import CommunitiesLayout from "./Layout";
import HelpApp from "../../communities/pages/help/App";

const Help = (props) => {
  return <HelpApp />;
};
Help.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>;
export default Help;
